module.exports = __webpack_public_path__ + "static/media/ihopa-cobuy-video.453a8558.mp4";